var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-font-color-switcher"},_vm._l((_vm.items),function(item){return _c('div',{key:item,staticClass:"kd-font-color-switcher__item",style:({
      backgroundColor: item,
    }),on:{"click":function($event){_vm.colorClicked(item)}}})}))}
var staticRenderFns = []

export { render, staticRenderFns }